import React, { useEffect, useState } from 'react';
import { getQuotes, updateQuoteStatus, deleteQuote } from './api';

export default function QuotesAdmin(){
  const [items, setItems] = useState<any[]>([]);

  useEffect(()=>{ load(); }, []);

  async function load(){
    const data = await getQuotes();
    setItems(data);
  }

  async function setStatus(id: number, status: string){
    await updateQuoteStatus({ id, status });
    await load();
  }

  async function onDelete(id: number){ if (!window.confirm('Delete quote?')) return; await deleteQuote(id); await load(); }

  return (
    <div>
      <h2 className="text-xl font-semibold mb-3">Quotes / Enquiries</h2>
      <div className="grid gap-2">
        {items.map(q => (
          <div key={q.id} className="p-3 border rounded">
            <div className="flex justify-between">
              <div>
                <div className="font-medium">{q.name} - <span className="text-sm text-slate-600">{q.email}</span></div>
                <div className="text-sm text-slate-700">{q.message}</div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <div className="text-sm">{q.status}</div>
                <div className="flex gap-1">
                  <button onClick={()=>setStatus(q.id,'contacted')} className="px-2 py-1 border rounded">Mark Contacted</button>
                  <button onClick={()=>setStatus(q.id,'closed')} className="px-2 py-1 border rounded">Close</button>
                  <button onClick={()=>onDelete(q.id)} className="px-2 py-1 border rounded text-rose-600">Delete</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
